import axios from 'axios';
import { cloneDeep } from 'lodash';
import { showToast } from '@inscribe/signal';

const defaultState = () => {
  return {
    // this object is purely for comparison purposes
    initialData: {},
    modified: false,
    data: {
      ui: {
        logo_url: undefined,
        heading: undefined,
        body_text: undefined,
        strip_color: undefined,
        cta_text_color: undefined,
        cta_bg_color: undefined,
      },
      email: {
        logo_url: undefined,
        subject: undefined,
        heading: undefined,
        body_text: undefined,
        strip_color: undefined,
        cta_text_color: undefined,
        bg_color: undefined,
        cta_text: undefined,
      },
      display_name: undefined,
      success_url: undefined,
      cancel_url: undefined,
      logo_href: undefined,
    },
  };
};

export default {
  state: defaultState(),
  mutations: {
    SET_CONFIG(state, configData) {
      state.data = configData;
    },
    SET_INITIAL_DATA_STATE(state, configData) {
      state.initialData = cloneDeep(configData);
    },
    MODIFIED_STATUS(state, status) {
      state.modified = status;
    },
    RESET_DATA_STATE(state) {
      state.data = cloneDeep(state.initialData);
    },
  },
  actions: {
    async getCollectConfig({ commit }) {
      try {
        const response = await axios.get('/api/v2/collect/config');

        commit('SET_CONFIG', response.data.data);
        commit('SET_INITIAL_DATA_STATE', response.data.data);
      } catch (error) {
        showToast({
          title: 'Error loading the Collect configuration.',
          text: error?.response?.data?.message,
          isError: true,
        });
      }
    },

    async saveCollectConfig({ commit }, configData) {
      try {
        // post to REST endpoint
        await axios.post('/api/v2/collect/config', configData);

        // mutate config state
        commit('SET_CONFIG', configData);
        commit('SET_INITIAL_DATA_STATE', configData);
        showToast({
          text: 'Collect configuration has been saved.',
        });
      } catch (error) {
        showToast({
          title: 'Error saving the Collect configuration.',
          text: error?.response?.data?.message,
          isError: true,
        });
      }
    },

    async uploadCollectConfigLogo({ commit }, logo) {
      try {
        const data = new FormData();
        data.append('image', logo);

        const axiosConfig = {
          method: 'post',
          url: '/api/v2/collect/config/logo',
          headers: {
            Accept: 'application/json',
          },
          data: data,
        };

        // post to REST endpoint
        const request = await axios(axiosConfig);

        // mutate config state
        commit('SET_CONFIG', request.data.data);
        commit('SET_INITIAL_DATA_STATE', request.data.data);
        showToast({
          text: 'Company Logo has been uploaded.',
        });
      } catch (error) {
        showToast({
          title: 'Company Logo upload has failed.',
          text: error?.response?.data?.message,
          isError: true,
        });
      }
    },

    updateModifiedStatus({ commit }, status) {
      commit('MODIFIED_STATUS', status);
    },

    resetDataFromInitialState({ commit }) {
      commit('RESET_DATA_STATE');
    },
  },
};
